/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';
import { css } from '@emotion/react';
import { theme } from '../../design-system/theme/theme';
import { stripTimePrecision } from './formatValue';

const linkStyle = css`
  color: ${theme.color.primary};
  text-decoration: underline;
  word-break: break-all;

  &:hover {
    opacity: 0.8;
  }
`;

/** 값 전체가 단일 http(s) URL인지 판별(공백 없이). */
const URL_RE = /^https?:\/\/\S+$/i;

/**
 * 셀 값이 http(s) URL이면 새 탭 링크로, 아니면 문자열로 렌더한다.
 * 컬럼명을 하드코딩하지 않고 값의 형태로만 판단 — 데이터 브라우저의 범용성 유지.
 * null/undefined는 대시(—)로 표시.
 */
export function linkifyValue(value: string | number | null | undefined): ReactNode {
  if (value === null || value === undefined) return '—';
  const s = stripTimePrecision(String(value));
  if (URL_RE.test(s.trim())) {
    return (
      <a css={linkStyle} href={s} target="_blank" rel="noreferrer noopener">
        {s}
      </a>
    );
  }
  return s;
}
